module.exports = __webpack_public_path__ + "img/wmpc_logo.b505875d.svg";